var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"copyright"},[_c('p',[_c('a',{attrs:{"href":"https://www.scsjb.cn"}},[_vm._v("四川手机报")]),_c('a',{attrs:{"href":"https://www.mala.cn"}},[_vm._v("麻辣社区")]),_c('a',{attrs:{"href":"http://www.newssc.org/"}},[_vm._v("四川新闻网")])]),_c('p',[_vm._v("Copyright © 2021 - 四川手机报")])])])
}]

export { render, staticRenderFns }